import {
	LaravelResponse,
	PagedMultiSelectField,
	PagedMultiSelectFieldProps,
	PagedSingleSelectField,
	laravelServiceSelectFetchConfig,
} from "@dgs/core";
import { FC } from "react";
import { contactService } from "../api/contactService";
import { IContactOptionResource } from "../types";

const fetchConfig = laravelServiceSelectFetchConfig(contactService);

export const getFullNameFromContactOption = (contact: IContactOptionResource) => {
	return `${contact.firstName} ${contact.lastName}` + (contact.email ? ` (${contact.email})` : "");
};

interface Props {
	name: string;
	label: string;
	required?: boolean;
	disabled?: boolean;
	readOnly?: boolean;
}

export const ContactSelectField: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} getLabel={getFullNameFromContactOption} />;
};

export const ContactMultiSelectField: FC<
	Props & {
		onChange?: PagedMultiSelectFieldProps<
			IContactOptionResource,
			LaravelResponse<IContactOptionResource[]>
		>["onChange"];
	}
> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} getLabel={getFullNameFromContactOption} />;
};
